// src/pages/Contact.jsx
import React from 'react';
import contactPageBg from '../assets/images/companyImg.JPG'; 
// Import your background image for the contact page

function Contact() {
  // Define the actual address that matches the map location
  // The address text is hardcoded as per your provided file.
  const addressText = "92 Barnes Road, Broxton, City of Johannesburg, Gauteng";
  const phoneNumber = "+27822154267";
  const emailAddress = "info@li-yo.org";

  // Google Maps Embed URL for "92 Barnes Road, Broxton, City of Johannesburg, Gauteng"
  // This URL has been updated to reflect the correct location.
  const googleMapsEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14325.29369931327!2d28.00760446738281!3d-26.17726588269784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950c609141f237%3A0x742e927598c0b2d4!2s92%20Barnes%20Rd%2C%20Broxton%2C%20Johannesburg%2C%202091%2C%20South%20Africa!5e0!3m2!1sen!2sza!4v1710000000000!5m2!1sen!2sza"; // Placeholder for actual timestamp

  return (
    // Outermost div: Acts as the container for the entire page and its background
    <div className="position-relative overflow-hidden">
      {/* Background Image Layer: Positioned absolutely to cover the entire outermost div */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${contactPageBg})`, // Use the imported background image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed', // Makes the background image static (parallax effect)
          opacity: 0.3, // Adjust opacity as needed for readability
          zIndex: 0, // Ensures it's behind the content
        }}
      ></div>

      {/* Main Content Wrapper: All visible page content goes here, positioned above the background */}
      <div className="container py-5 position-relative z-1">
        <h1 className="mb-4 text-center display-4 fw-bold text-dark">Contact Us</h1>
        <p className="lead text-center mb-5 ">
          We'd love to hear from you. Reach out to us for inquiries, quotes, or any construction needs.
        </p>

        {/* Combined Contact Information, Business Hours, and Map Section */}
        <section className="py-1  mb-5 position-relative z-1">
          <div className="row g-5 justify-content-center">
            {/* Left Column: Contact Info, Business Hours, and MAP */}
            <div className="col-md-6  col-lg-5">
              <h3 className="mb-3 " >LIYO AND SONS GROUP</h3>
              {/* Phone with Icon */}
              <p className="mb-2 d-flex align-items-center">
                <i className="bi bi-phone-fill me-2 text-warning transition-transform hover:scale-110"></i> {/* Phone Icon with warning color and animation */}
                <a href={`tel:${phoneNumber}`} className="text-decoration-none text-dark">{phoneNumber}</a>
              </p>
              {/* Email with Icon */}
              <p className="mb-2 d-flex align-items-center">
                <i className="bi bi-envelope-fill me-2 text-warning transition-transform hover:scale-110"></i> {/* Email Icon with warning color and animation */}
                <a href={`mailto:${emailAddress}`} className="text-decoration-none text-dark">{emailAddress}</a>
              </p>
              {/* Address with Icon */}
              <p className="mb-2 d-flex align-items-start"> {/* Use align-items-start for multi-line address */}
                <i className="bi bi-geo-alt-fill me-2 text-warning flex-shrink-0 mt-1 transition-transform hover:scale-110"></i> {/* Location Icon with warning color and animation */}
                {addressText}
              </p>
              <hr className="my-4" />
              <h4 className="mb-3">Business Hours</h4>
              <p className="mb-0">Monday - Friday: 8:00 AM - 5:00 PM</p>
              <p>Saturday - Sunday: Closed</p>

              {/* Moved Map Section here */}
              <div className="mt-3"> {/* Added top margin to separate from business hours */}
                <h4 className="mb-2">Find Us on the Map</h4> {/* Changed to h4 for hierarchy */}
                <div className="map-container rounded shadow-sm overflow-hidden" style={{ height: '250px', width: '100%' }}> {/* Reduced height */}
                  {/* Google Maps Embed */}
                  <iframe
                    src={googleMapsEmbedUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="LIYO & SONS Location"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Right Column: Contact Form */}
            <div className="col-md-6 col-lg-5 text-dark ">
  <h3 className="mb-3">Send Us a Message</h3>
  <form>
    <div className="mb-3">
      <label htmlFor="name" className="form-label">Your Name</label>
      <input type="text" className="form-control" id="name" placeholder="Name Surname" required />
    </div>
    <div className="mb-3">
      <label htmlFor="email" className="form-label">Email Address</label>
      <input type="email" className="form-control " id="email" placeholder="name@example.com" required />
    </div>
    <div className="mb-3">
      <label htmlFor="subject" className="form-label">Subject</label>
      <input type="text" className="form-control" id="subject" placeholder="Project Inquiry" />
    </div>
    <div className="mb-3">
      <label htmlFor="message" className="form-label">Your Message</label>
      <textarea
        className="form-control"
        id="message"
        rows="8"
        required
        style={{
          resize: 'none',
          borderColor: 'var(--bs-warning-border-subtle)' 
        }}
      ></textarea>
    </div>
    <button type="submit" className="btn btn-outline-warning  me-md-2 mb-2 mb-md-0 btn-lg">Submit</button>
  </form>
</div>
</div>
        </section>
      </div> {/* End of main content wrapper */}
    </div> // End of outermost div
  );
}

export default Contact;
